import API from '../constants/api';

export const sendOrderConfirmationCode = (fetch, hash) =>
  fetch(API.POLIS.CONFIRM_ORDER(hash), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  }).then(res => res.json());

export const checkOrderConfirmationCode = (fetch, hash, code) =>
  fetch(API.POLIS.CONFIRM_ORDER(hash), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code }),
  }).then(res => res.json());



// WEBPACK FOOTER //
// ./src/shared/network/polis.js